export enum CandidateStatus {
  PENDING = "pending",
  SHORTLISTED = "shortlisted",
  INTERVIEWING = "interviewing",
  INTERVIEWED = "interviewed",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  HIRED = "hired"
}

/** Default pipeline stage semantics (job-scoped stages may also be `custom`). */
export type PipelineStageType =
  | 'pending'
  | 'shortlisted'
  | 'interviewing'
  | 'interviewed'
  | 'accepted'
  | 'hired'
  | 'rejected'
  | 'custom'; 